import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Price from '../atoms/text/Price';
import RadioSingle from '../atoms/form/RadioSingle';
import { AIRLINES, BOOKING_CLASS_CLASS_J } from '../../constants';
import TextLink from '../atoms/link/Textlink';
import ModalConnectingFlights from '../modal/ModalConnectingFlights';
import { getFlightNameAndLogoPath, makeClassJFlight } from '../../utils/plain';

const PlanePlanTableItem = ({
  flight, selectedFlight, isSelectedDateShowing, handleSelectFlight, tableId,
}) => {
  const [open, setOpen] = useState(false);

  const {
    id,
    carrierName,
    departureTime,
    arrivalTime,
    seatStatus,
    price,
    connectingFlights,
    departureAirportName,
    arrivalAirportName,
    upgrades,
    operationCarrier,
    airline,
  } = flight;
  const selectedFlightPrice = selectedFlight && selectedFlight.price;

  const available = seatStatus === 'Vacant';
  const availableDisplay = available ? '○' : '×';

  const checked = isSelectedDateShowing && validateChecked(flight, selectedFlight)
    && (selectedFlight.airline === AIRLINES.jal ? selectedFlight.bookingClass !== BOOKING_CLASS_CLASS_J : true);

  const priceDiff = price - selectedFlightPrice;

  const { flightName, logoPath } = getFlightNameAndLogoPath(flight);

  const hasClassJ = !!(upgrades && upgrades.length && upgrades[0].class === 'ClassJ');

  return (
    <React.Fragment>
      <tr
        className={checked ? 'active' : available ? 'clickable' : ''}
        onClick={() => {
          if (available) {
            handleSelectFlight(flight);
          }
        }}
      >
        <td>
          <div className="planePlanTableRadio">
            {available && <RadioSingle radioId={`${tableId}-${id}`} radioName={tableId} checked={checked} />}
          </div>
        </td>
        <td>
          <div className="planePlanTableFlightType">
            <div className="planePlanTableFlightLogo">
              {logoPath ? (
                <img src={`/dpp/img/logo/${logoPath}`} alt="" />
              ) : (
                <strong style={{ width: 48 }}>{carrierName}</strong>
              )}
            </div>
            <div className="planePlanTableFlightName">
              {connectingFlights && connectingFlights.length ? (
                <React.Fragment>
                  <div className="planePlanTableFlightNumber">
                    {flightName}
                  </div>
                  <div className="planePlanTableFlightSup">
                    <TextLink onClick={(e) => {
                      e.stopPropagation();
                      setOpen(true);
                    }}>
                      乗継便あり
                    </TextLink>
                  </div>
                  <ModalConnectingFlights
                    open={open}
                    onClose={() => setOpen(false)}
                    connectingFlights={connectingFlights}
                    selectedAirline={airline}
                  />
                </React.Fragment>
              ) : (
                <div className="planePlanTableFlightNumber">
                  {flightName}
                  {operationCarrier && (
                    <React.Fragment>
                      <br/>
                      <span className="planePlanTableCarrierName">{operationCarrier}運航</span>
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          </div>
        </td>
        <td >
          <div className="planePlanTableAirportName">{departureAirportName}</div>
          <div className="planePlanTableFlightTime">{departureTime}</div>
        </td>
        <td>
          <div className="planePlanTableAirportName">{arrivalAirportName}</div>
          <div className="planePlanTableFlightTime">{arrivalTime}</div>
        </td>
        <td>{availableDisplay}</td>
        {(available && !checked) ? (
          <td>
            <Price
              className="planePlanTablePrice"
              priceType={priceDiff >= 0 ? 'red' : 'blue'}
            >
              {priceDiff >= 0 ? '+' : ''}
              {typeof priceDiff === 'number' && priceDiff.toLocaleString()}
              円
            </Price>
          </td>
        ) : (
          <td>
            {checked ? (
              <div className="hyphen">選択中</div>
            ) : (
              <div className="hyphen">-</div>
            )}
          </td>
        )}
      </tr>
      {hasClassJ && (
        <ClassJOption
          tableId={tableId}
          flight={flight}
          selectedFlight={selectedFlight}
          handleSelectFlight={handleSelectFlight}
          isSelectedDateShowing={isSelectedDateShowing}
        />
      )}
    </React.Fragment>
  );
};

PlanePlanTableItem.propTypes = {
  tableId: PropTypes.string.isRequired,
  flight: PropTypes.object.isRequired,
  selectedFlight: PropTypes.object,
  isSelectedDateShowing: PropTypes.bool.isRequired,
  handleSelectFlight: PropTypes.func.isRequired,
};

export default PlanePlanTableItem;

const ClassJOption = ({
  flight, selectedFlight, isSelectedDateShowing, handleSelectFlight, tableId,
}) => {
  const {
    id,
    upgrades,
  } = flight;
  const selectedFlightPrice = selectedFlight && selectedFlight.price;

  const classJSeatStatus = upgrades[0].seatStatus;
  const available = classJSeatStatus === 'Vacant';
  const availableDisplay = available ? '○' : '×';

  const checked = isSelectedDateShowing && validateChecked(flight, selectedFlight)
    && (selectedFlight.airline === AIRLINES.jal ? selectedFlight.bookingClass === BOOKING_CLASS_CLASS_J : true);

  const classJPrice = upgrades[0].price;
  const priceDiff = classJPrice - selectedFlightPrice;

  return (
    <tr
      className={checked ? 'active' : available ? 'clickable' : ''}
      onClick={() => {
        if (available) {
          handleSelectFlight(makeClassJFlight(flight));
        }
      }}
    >
      <td>
        <div className="planePlanTableRadio">
          {available && <RadioSingle radioId={`${tableId}-${id}-classJ`} radioName={tableId} checked={checked} />}
        </div>
      </td>
      <td colSpan={3}>
        <div className="classJItem">
          上記航空便のクラスJを利用する
          <img src="/dpp/img/logo/jclass.png" alt="" />
        </div>
      </td>
      <td>{availableDisplay}</td>
      {(available && !checked) ? (
        <td>
          <Price
            className="planePlanTablePrice"
            priceType={priceDiff >= 0 ? 'red' : 'blue'}
          >
            {priceDiff >= 0 ? '+' : ''}
            {typeof priceDiff === 'number' && priceDiff.toLocaleString()}
            円
          </Price>
        </td>
      ) : (
        <td>
          {checked ? (
            <div className="hyphen">選択中</div>
          ) : (
            <div className="hyphen">-</div>
          )}
        </td>
      )}
    </tr>
  );
};

ClassJOption.propTypes = {
  tableId: PropTypes.string.isRequired,
  flight: PropTypes.object.isRequired,
  selectedFlight: PropTypes.object,
  isSelectedDateShowing: PropTypes.bool.isRequired,
  handleSelectFlight: PropTypes.func.isRequired,
};

const validateChecked = (flight, selectedFlight) => {
  if (!selectedFlight || !flight) {
    return false;
  }

  const hasSelectedFlightsConnecting = !!(selectedFlight.connectingFlights && selectedFlight.connectingFlights.length);
  const hasFlightsConnecting = !!(flight.connectingFlights && flight.connectingFlights.length);

  if (hasSelectedFlightsConnecting !== hasFlightsConnecting) {
    return false;
  }

  const connectingFlightsMathed = hasFlightsConnecting ? (
    flight.connectingFlights[0].id === selectedFlight.connectingFlights[0].id &&
    flight.connectingFlights[1].id === selectedFlight.connectingFlights[1].id
  ) : true;

  return selectedFlight.id === flight.id && connectingFlightsMathed;
};
